const apiBaseUrl = "https://hints-app.herokuapp.com/api"
// const apiBaseUrl = "http://localhost:8080/api"


export default apiBaseUrl


// WEBPACK FOOTER //
// ./src/API.js